import { Component, EventEmitter, OnInit, Output, Input, inject } from '@angular/core';
import { restManager } from 'app/ajs-upgraded-providers';
import { UserActiveSessionManagerService } from 'src/app/core';
import { TabSettingsUmService } from './service/tab-settings-um.service';

@Component({
	standalone: false,
  selector: 'app-tab-settings-um',
  templateUrl: './tab-settings-um.component.html',
  styleUrls: ['./tab-settings-um.component.scss']
})
export class TabSettingsUmComponent implements OnInit {
    protected restManagerService = inject(restManager);
    protected userActiveSessionManagerService = inject(UserActiveSessionManagerService);
    protected tabSettingsUmService = inject(TabSettingsUmService);
    protected shopOwner: any = {};

    @Output() tabPanelChange = new EventEmitter<number>();
    @Input() getTabChange!: number;

    constructor() { }

    ngOnInit() {
      this.getShopOwner();
    }

    async getShopOwner() {
      await this.tabSettingsUmService.getShopOwner();
    }
}
